export default __webpack_public_path__ + "static/media/23t.725f2a16.jpg";